import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { openAuthModal } from '../../Actions/UIActions';
import cn from 'classnames';
import './CreatorOnboardingRegistrationCodePanel.scss';
import Loader from '../Loader/Loader';
import { getAndRemoveUrlParam } from '../../Helpers/helpers';
import { getWaitlistInfoFromRegistrationCode } from '../../APIClient/users';

const CreatorOnboardingRegistrationCodePanel = props => {
  const { goToNextPanel, updateOnboardingData, openAuthModal } = props;

  const codeFromUrl = getAndRemoveUrlParam('smscode');
  const autoSubmitCode = codeFromUrl && getAndRemoveUrlParam('autoSubmitCode') === 'true';

  const [loading, setLoading] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [code, setCode] = useState(codeFromUrl || '');
  const [readyToRender, setReadyToRender] = useState(!autoSubmitCode);

  const enterCode = (codeToSubmit) => {
    setLoading(true);
    getWaitlistInfoFromRegistrationCode(codeToSubmit).then(data => {
      updateOnboardingData({ waitlistInfoFromRegistrationCode: data });
      setLoading(false);
      if (autoSubmitCode) {
        goToNextPanel();
      } else {
        setFadeOut(true);
      }
    }).catch(err => {
      setLoading(false);
      if (!autoSubmitCode) {
        window.ALERT.error(err || 'Unknown error. Please contact support for assistance.');
      } else {
        // Rather than show an error with no context, let the user try again manually
        // a) in case the error was spurious
        // b) so they know why the error happened if it reoccurs
        setReadyToRender(true);
      }
    });
  }

  const onAnimationEnd = () => {
    if (fadeOut) {
      goToNextPanel();
    }
  };

  useEffect(() => {
    if (autoSubmitCode) {
      enterCode(codeFromUrl);
    }
  }, [])

  return !readyToRender ? null : (
    <div className='creator-onboarding-registration-code-outer'>
      <div className={'creator-onboarding-registration-code-inner'}>
        {/* Need to add animations/fade-out to all child elements separately, because backdrop-filter on the input */}
        {/* doesn't work if a parent element has an animation property. The animations are all in sync, so the */}
        {/* onAnimationEnd callback is arbitrarily put on the first element */}
        <div className={cn('creator-onboarding-registration-code-header-small', fadeOut && 'fade-out')} onAnimationEnd={onAnimationEnd}>Welcome to ShopMy</div>
        <div className={cn('creator-onboarding-registration-code-header-large', fadeOut && 'fade-out')}>Enter your Invitation Code</div>
        <div className='creator-onboarding-registration-code-input-container'>
          <input 
            type='text' 
            autoFocus={true}
            className={cn('creator-onboarding-registration-code-input', fadeOut && 'fade-out')} 
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder='Invitation code' 
          />
          <button className={cn('creator-onboarding-registration-code-enter-button', fadeOut && 'fade-out')} onClick={() => enterCode(code)}>
            {loading ? (
              <Loader size={64} color='#fff' />
            ) : (
              'Enter Code'
            )}
          </button>
        </div>
        <div className={cn('creator-onboarding-registration-code-body', fadeOut && 'fade-out')}>
          Already have an account? <a href='javascript:void(0);' onClick={() => openAuthModal('login')}>Log In</a>.
          <br/>
          Don't have an Invitation Code? <a href='/apply/creator'>Apply</a>.
        </div>
      </div>
    </div>
  );
}

export default connect(null, {
  openAuthModal,
})(CreatorOnboardingRegistrationCodePanel);